import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import DropdownMenu from "../../components/DropdownMenu";
import SEO from "../../context/SEO";
import styles from "./style.module.scss";
import banner from "../../assets/contact/bowlDesk.avif";

function Contact() {
  const [showElements, setShowElements] = useState("full-opacity");
  const vh = window.innerHeight * 0.01;

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (
      currentScrollPos > -20 * vh &&
      currentScrollPos < 10 * vh &&
      showElements === "full-opacity"
    ) {
    } else if (currentScrollPos > -20 * vh && currentScrollPos < 10 * vh) {
      setShowElements("fade-in-up");
    } else {
      setShowElements("fade-out-up");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showElements]);

  return (
    <div>
      <SEO title="Cork Matters - Contact" />
      <DropdownMenu showElements={showElements} iconColour="white" />
      <div className={styles.banner}>
        <img src={banner} alt="Orb Family Banner" />
        <div className={styles.bannerText}>
          <h1>Contact</h1>
        </div>
      </div>
      <div className={styles.grid}>
        <div className={styles.openingHoursContainerContact}>
          <div className={styles.openingHoursContainer}>
            <div className={styles.title}>Opening Hours</div>
            <div className={styles.days}>
              <p> Monday: </p>
              <p> Tuesday: </p>
              <p> Wednesday: </p>
              <p> Thursday: </p>
              <p> Friday: </p>
              <p> Saturday: </p>
              <p> Sunday:</p>
            </div>
            <div className={styles.openingHours}>
              <p> 11:00 - 19:30 PM</p>
              <p> Closed </p>
              <p> 11:00 - 19:30 PM</p>
              <p> 11:00 - 19:30 PM</p>
              <p> 11:00 - 19:30 PM</p>
              <p> 11:00 - 20:00 PM</p>
              <p> Closed </p>
            </div>
          </div>
          <div className={styles.meetingBookingsContainer}>
            <div className={styles.meetingBookingsTitle}>
              For Meeting Bookings
            </div>
            <div className={styles.meetingBookings}>Call: +351 91 966 1000</div>
          </div>
        </div>
        <div className={styles.map}>
          <div className={styles.contactGoogleMap}>
            <iframe
              title="google-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d37977.062314783434!2d-8.631359796817232!3d41.14855914583758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd246530935b1b27%3A0x8d824bac73db09f1!2sCork%20Matters%20Concept%20Store!5e0!3m2!1sen!2snl!4v1702484374739!5m2!1sen!2snl"
              style={{ border: "0" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      <div className={styles.grid}>
        <div className={styles.addressMainTitle}>Address</div>
        <div className={styles.addressStore}>
          <div className={styles.addressTitle}>
            Cork Matters Design Concept Store
          </div>
          <div className={styles.address}>
            <p>Rua do Rosário 143 - 145</p>
            <p>4050 519 Porto</p>
            <p>Portugal</p>
          </div>
          <div className={styles.emailAndLink}>
            <a
              href="mailto:apeixoto@simpleformsdesign.com"
              className={styles.emailAddress}
            >
              apeixoto@simpleformsdesign.com
            </a>
            <a
              href="https://www.corkmatter.com"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              www.corkmatter.com
            </a>
          </div>
        </div>
        <div className={styles.addressStudio}>
          <div className={styles.addressTitle}>Cork Matters Design Studio</div>
          <div className={styles.address}>
            <p>Rua Anselmo Braancamp 86</p>
            <p>4000 078 Porto</p>
            <p>Portugal</p>
          </div>
          <div className={styles.emailAndLink}>
            <a
              href="mailto:corkmatters.online@gmail.com"
              className={styles.emailAddress}
            >
              corkmatters.online@gmail.com
            </a>
            <a
              href="https://www.simpleformsdesign.com"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              www.simpleformsdesign.com
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
